export default __webpack_public_path__ + "static/hero_right-545ba562746d5e096bee0f9620de43cf.png";